export default {
  // 获取父级菜单节点
  async getParentNode(store, node) {
    if (node && node.parentId === '0') {
      return node
    }
    const pNode = this.getters.platMainMenus.find(
      (item) => item.id === node.parentId
    )
    const res = pNode ? await this.dispatch('getParentNode', pNode) : pNode
    return res
  },
  // 获取模块级菜单节点
  async getModuleNode({ state, commit }, node) {
    const config = {
      savePath: false,
      ...node,
    }
    if (!node) {
      return node
    }
    // 按需求存储路径
    if (config.savePath) {
      state.breadNav.unshift(node)
      commit('setBreadNav', state.breadNav)
    }
    if (node.level === '0') {
      return node
    }
    const pNode = this.getters.platMainMenus.find(
      (item) => item.id === node.parentId
    )
    const res = pNode
      ? await this.dispatch('getModuleNode', {
          ...pNode,
          savePath: config.savePath,
        })
      : pNode
    return res
  },
  // 获取指定路径模块节点
  async getPathModuleNode(store, opt = {}) {
    const config = {
      path: '',
      savePath: false,
      ...opt,
    }
    const node = this.getters.platMainMenus.find(
      (item) => item.link === config.path
    )
    const res = node
      ? await this.dispatch('getModuleNode', {
          ...node,
          savePath: config.savePath,
        })
      : node
    return res
  },
}
